// https://shopify.dev/docs/api/storefront/2023-10/mutations/checkoutcustomerdisassociatev2
export const checkoutCustomerDisassociateV2 = `
mutation checkoutCustomerDisassociateV2($checkoutId: ID!) {
  checkoutCustomerDisassociateV2(checkoutId: $checkoutId) {
    checkout{
      id
    }
    userErrors {
      field
      message
    }
    checkoutUserErrors {
      code
      field
      message
    }
  }
}`
